import { PolicySignState } from "./types";

export const defaultState = (): PolicySignState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    signedPolicies: [],
    links: {}
  };
};

export const state = defaultState();
